var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeo01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "geo...") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "20.08 32.68 14.83 32.68 8.64 55.15 51.36 55.15 45.64 32.68 39.75 32.68 40.43 39.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.64,
    y1: 55.15,
    x2: 46.95,
    y2: 37.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.89,
    y1: 55.15,
    x2: 33.52,
    y2: 43.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.87,
    y1: 39.75,
    x2: 21.25,
    y2: 48.37
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.62,14.62a11.8,11.8,0,0,1-1.15,5.54l-9,18.22c0,.21-.14.56-.42.58s-.33-.35-.42-.56C26.53,32.26,23.47,26.14,20.46,20a10.6,10.6,0,1,1,19.17-9.06A10.75,10.75,0,0,1,40.62,14.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.22,15.39A5.23,5.23,0,1,0,30,20.65h0A5.26,5.26,0,0,0,35.22,15.39Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo01);
export default __webpack_public_path__ + "static/media/geo_01.90261c5dae1bea6786c54dc683be30a0.svg";
export { ForwardRef as ReactComponent };